import '@grandvisionhq/utils';
import { getUnlocalizedSpecificationItem } from '../utils/get-unlocalized-specification-item.js';
import '@swc/helpers';
import '@grandvisionhq/graphql';
import '../../../types/product.js';
import { getSpecificationItems } from '../utils/get-specification-items.js';
import { mapServerToSpecificationsBase } from './map-server-to-specifications-base.js';

const mapServerToAccessoriesSpecifications = (serverVariant, brand)=>{
    const { targetGender , targetGenderAllLocales , color , colorAllLocales , accessoryType , material , materialAllLocales ,  } = serverVariant.variantTypeDetails;
    const genderUnlocalized = getUnlocalizedSpecificationItem(targetGenderAllLocales);
    const materialUnlocalized = getUnlocalizedSpecificationItem(materialAllLocales);
    const accessoryColorUnlocalized = getUnlocalizedSpecificationItem(colorAllLocales);
    const accessoryTypeUnlocalized = getUnlocalizedSpecificationItem(accessoryType === null || accessoryType === void 0 ? void 0 : accessoryType.displayNameAllLocales);
    const serverSpecifications = {
        targetGender,
        genderUnlocalized,
        accessoryColor: color,
        accessoryColorUnlocalized,
        accessoryType: accessoryType === null || accessoryType === void 0 ? void 0 : accessoryType.displayName,
        accessoryTypeUnlocalized,
        material,
        materialUnlocalized
    };
    return [
        ...mapServerToSpecificationsBase(serverVariant, brand),
        ...getSpecificationItems(serverSpecifications), 
    ];
};

export { mapServerToAccessoriesSpecifications };
//# sourceMappingURL=map-server-to-accessories-specifications.js.map
